import { AppActions, AppActionTypes } from '../actions/app.actions';

export interface State {
  loading: boolean;
  localeId: string | null;
  workflow_id: number | null;
}

export const initialState: State = {
  loading: false,
  localeId: null,
  workflow_id: null,
};

export function reducer(state = initialState, action: AppActions): State {
  switch (action.type) {
    case AppActionTypes.StartLoading:
      return { ...state, loading: true };
    case AppActionTypes.StopLoading:
      return { ...state, loading: false };
    case AppActionTypes.SetLocaleId:
      return { ...state, localeId: action.payload.localeId };
    case AppActionTypes.SetWorkflowId:
      return { ...state, workflow_id: action.payload.workflowId };
    default:
      return state;
  }
}
